import PropTypes from 'prop-types';
import { Inline, breakpoints } from '@etg/wings';
import { css } from '@eti/styles';
import PaymentMethodLogoLoaderContainer from '../containers/PaymentMethodLogoLoaderContainer';

const paymentMethodLogoStyles = css`
  border-radius: 2px;
  box-sizing: border-box;
  flex-shrink: 0;
  height: 24px;
`;

const containerStyle = css`
  margin: 10px 0 0;
`;

const PaymentLogoList = ({ methods = [] }) => (
  <div className={containerStyle}>
    <Inline spacing={{ [breakpoints._0]: 4, [breakpoints._560]: 8 }}>
      {methods.map(({ filename, id, type }) => (
        <PaymentMethodLogoLoaderContainer
          className={paymentMethodLogoStyles}
          filename={filename}
          key={id}
          type={type}
        />
      ))}
    </Inline>
  </div>
);

PaymentLogoList.propTypes = {
  methods: PropTypes.arrayOf(
    PropTypes.shape({
      filename: PropTypes.string,
      id: PropTypes.number,
      type: PropTypes.string,
    }),
  ),
};

export default PaymentLogoList;
